import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import i18next from 'i18next';
import AssignmentIcon from '@material-ui/icons/Assignment';
import BallotIcon from '@material-ui/icons/Ballot';
import SurveyPresentation from './SurveyPresentation'
import SurveyQuestions from './SurveyQuestions'
import AlertAlgo from '../controls/AlertSnack'

import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    tab: {
        display: 'flex'
    }
}));

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabPanelSurveyDetail(props) {
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);
    const [dataSurvey, setDataSurvey] = React.useState(null);
    const [dataPresentation, setDataPresentation] = React.useState(null);
    const [hasPresentation, setHasPresentation] = React.useState(false);
    const alertRef = useRef(null);

    useEffect(() => {
        if (dataSurvey != null) {
            validateDisplayTab();
        }
    }, [dataSurvey])

    useEffect(() => {
        if (props.data != null) {
            setDataSurvey(props.data.survey);
            setDataPresentation(props.data.presentation);
        }
    }, [props.data])

    const validateDisplayTab = () => {
        const showPresentation = dataSurvey.isPresentationShown;

        setHasPresentation(showPresentation);

        if (!showPresentation) {
            setIndex(1);
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handlePresentationClick = () => {
        setIndex(0);
    }

    const handleQuestionsClick = () => {
        setIndex(1);
    }

    const showMessageWarning = (message) => {
        alertRef.current.showMessageWarning(message);
    }

    const handleLoadSurvey = () => {
        props.handleLoadSurvey(true);
    }

    const classes = useStyles();

    return (
        <div className={classes.divRoot}>
            <div className={classes.tab}>
                <AppBar position="static" color="default">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        indicatorColor="primary"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        {hasPresentation && <Tab className={"TabPageButton"} label={i18next.t("survey:tabPanel.presentation")} {...a11yProps(0)} onClick={handlePresentationClick} />}
                        <Tab className={"TabPageButton"} label={i18next.t("survey:tabPanel.questions")} {...a11yProps(1)} onClick={handleQuestionsClick} />
                    </Tabs>
                </AppBar>
            </div>

            <div className={classes.contentTab}>
                {index == 0 && hasPresentation && <SurveyPresentation data={dataPresentation} />}
                {index == 1 && <SurveyQuestions surveyId={dataSurvey.surveyId} status={dataSurvey.status} showMessageWarning={showMessageWarning} handleLoadSurvey={handleLoadSurvey} />}
            </div>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['survey'], { wait: true })(TabPanelSurveyDetail);